<template>
  <v-container class="text-center">
    <h1>{{$t('message.inactive_account')}}</h1>
    <icon-like size="400px" class="rotate" color="red"></icon-like>
    <div class="text-center mt-2 pt-2">
      <v-btn @click="backToCheckins()" color="secondary" large>
        <v-icon>autorenew</v-icon>
      </v-btn>
    </div>
  </v-container>
</template>

<script>
import IconLike from '@/components/displays/icons/IconLike.vue';
export default {
  components: {
    IconLike
  },
  methods:{
    backToCheckins(){
      this.navigateTo({ name: "checkin" });
    }
  }
}
</script>

<style scoped>
.rotate{
  -webkit-transform:rotate(180deg);
  -moz-transform: rotate(180deg);
  -ms-transform: rotate(180deg);
  -o-transform: rotate(180deg);
  transform: rotate(180deg);
}
</style>
